import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { MdClose } from 'react-icons/md'

export const isIos = () => /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase())

export const isInStandaloneMode = () => 'standalone' in window.navigator && window.navigator.standalone

const AddToHomescreen = ({ onAddToHomescreenClick, title, icon }) => {
  const [bannerVisible, setBannerVisible] = useState(true)

  if (!bannerVisible || !isIos() || isInStandaloneMode()) return null

  return (
    <div className='add-to-home-banner'>
      <div className='add-to-home-content'>
        {icon && <img className='add-to-home-icon' src={icon} alt='' />}
        <div className='add-to-home-text'>
          <a onClick={onAddToHomescreenClick}>{title}</a>
        </div>
      </div>
      <MdClose className='add-to-home-close-btn' onClick={() => setBannerVisible(false)} />
    </div>
  )
}

AddToHomescreen.propTypes = {
  onAddToHomescreenClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string
}

export default AddToHomescreen
